import React from "react";

/**
 * Small inline placeholder for a section that has no data yet (e.g. no
 * portfolio images, no products). Used instead of silently rendering
 * nothing, so an owner previewing a freshly-created site understands
 * what will show once they add content.
 */
export default function SiteEmptyState({ icon = "bi-inbox", title, message }) {
    return (
        <div
            style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#9ca3af",
                border: "1px dashed #e5e7eb",
                borderRadius: 16,
                background: "rgba(0,0,0,0.015)",
            }}
        >
            <i className={`bi ${icon}`} style={{ fontSize: 28, display: "block", marginBottom: 10 }} aria-hidden="true" />
            {title && <p style={{ margin: "0 0 4px", fontWeight: 700, color: "#6b7280" }}>{title}</p>}
            {message && <p style={{ margin: 0, fontSize: 14 }}>{message}</p>}
        </div>
    );
}
